import React, { Component } from 'react';
import { Breadcrumb, Button, Card, Col, Form, Input, message, Popconfirm, Row, Table } from 'antd';
import { queryDeleteDict, queryDictInfo, queryDictListTree, querySaveDict } from '@api/core/dict';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import ModalDictAdd from './ModalDictAdd';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      total: 0,
      pageNo: 1,
      pageSize: 15,
      isPermission: false,
      visible: false,
      parentLevelCode: '',
      breadcrumbDicts: [],
      dataInfo: null,
    };
  }

  componentDidMount() {
    this.loadData(null, 1);
    this.judge(this.props.account_info);
  }

  componentWillUnmount() {
    const { pageNo, condition } = this.state;
    const params = {
      pageNo,
      condition,
    };
    this.props.dispatch(setBackInfo(params));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  // 加载需公司账户信息数据
  loadData = (dict, pageNo, pageSize) => {
    const params = {};
    const { condition, pageNo: no } = this.state;
    let { breadcrumbDicts } = this.state;
    const current = pageNo || no;
    params.limit = pageSize || 10;
    params.start = current;
    params.condition = condition || '';
    if (dict) {
      params.parentLevelCode = dict.levelCode || '';
    } else {
      params.parentLevelCode = '';
    }
    this.setState({
      pageNo: current,
      pageSize,
      isLoading: true,
      parentLevelCode: params.parentLevelCode,
    });
    queryDictListTree(params).then(res => {
      if (res.statusCode === 200) {
        if (dict) {
          if (breadcrumbDicts.indexOf(dict) > -1) {
            breadcrumbDicts = breadcrumbDicts.slice(0, breadcrumbDicts.indexOf(dict));
          }
          breadcrumbDicts.push(dict);
        } else {
          breadcrumbDicts = [];
        }
        this.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
          breadcrumbDicts,
        });
      }
    });
  };

  searchData = () => {
    const { breadcrumbDicts } = this.state;
    const dict = breadcrumbDicts[breadcrumbDicts.length - 1];
    this.loadData(dict, 1, 10);
  };

  loadDataOnClick = dict => {
    this.props.form.setFieldsValue({
      condition: '',
    });
    this.setState({ condition: '' }, () => {
      this.loadData(dict, 1);
    });
  };

  // 字典详情
  getDictInfo = uuid => {
    queryDictInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data || [],
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  saveDict = params => {
    querySaveDict(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handlerVisible(false);
        this.setState({ dataInfo: null });
        this.searchData();
      } else {
        message.error(res.message);
      }
    });
  };

  deleteDict = uuid => {
    queryDeleteDict({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.searchData();
      } else {
        message.error(res.message);
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            condition: values.condition,
          },
          () => {
            this.searchData();
          },
        );
      }
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition } = this.state;
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
          <FormItem>
            {getFieldDecorator('condition', {
              initialValue: condition || null,
            })(<Input placeholder="请输入关键字" />)}
          </FormItem>
          <FormItem>
            <Button htmlType="submit">查询</Button>
          </FormItem>
        </Form>
      </div>
    );
  };

  judge = accountInfo => {
    let isPermission = false;
    if (accountInfo.admin) {
      isPermission = true;
    }

    this.setState({
      isPermission,
    });
  };

  handlerVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  columns = () => {
    return [
      {
        title: '名称',
        dataIndex: 'name',
        render: (text, record) => {
          return <span onClick={() => this.loadDataOnClick(record)}>{text}</span>;
        },
      },
      {
        title: '分类代码',
        dataIndex: 'charCode',
      },
      {
        title: '状态',
        dataIndex: 'status',
        render: text => {
          return <span>{text === 1 ? '启用' : '禁用'}</span>;
        },
      },
      {
        title: '操作',
        render: (text, record) => {
          const { isPermission } = this.state;
          return (
            <span>
              {isPermission ? (
                <span>
                  <a onClick={() => this.editDict(record.uuid)}>编辑</a>
                  <span className="ant-divider" />
                  <Popconfirm
                    onConfirm={() => this.deleteDict(record.uuid)}
                    title="确定删除当前字典数据吗？"
                    placement="topRight"
                    overlayStyle={{ width: 200 }}
                  >
                    <a className="ant-dropdown-link">删除</a>
                  </Popconfirm>
                </span>
              ) : null}
            </span>
          );
        },
      },
    ];
  };

  addDict = () => {
    this.setState({ dataInfo: null });
    this.handlerVisible(true);
  };

  editDict = uuid => {
    this.getDictInfo(uuid);
    this.handlerVisible(true);
  };

  render() {
    const {
      data,
      isLoading,
      total,
      pageNo,
      pageSize,
      isPermission,
      parentLevelCode,
      breadcrumbDicts,
      visible,
      dataInfo,
    } = this.state;
    const dict = breadcrumbDicts[breadcrumbDicts.length - 1];
    const pagination = {
      showSizeChanger: true,
      pageSize,
      total,
      current: pageNo,
      pageSizeOptions: ['10', '50', '100', '200', '500'],
      onShowSizeChange: (current, size) => {
        this.loadData(dict, current, size);
      },
      onChange: current => {
        this.loadData(dict, current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <div>
        <Card>
          <Row style={{ paddingBottom: '20px' }}>
            <Col span={13}>
              {isPermission ? (
                <Button type="primary" onClick={this.addDict}>
                  添加
                </Button>
              ) : null}
            </Col>

            <Col span={11}>
              <div className="tableListForm">{this.renderSearchForm()}</div>
            </Col>
          </Row>
          <div className="tableList">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => this.loadDataOnClick(null)}>root</Breadcrumb.Item>
              {breadcrumbDicts.map(breadcrumbDict => {
                return (
                  <Breadcrumb.Item
                    key={breadcrumbDict.uuid}
                    onClick={() => this.loadDataOnClick(breadcrumbDict)}
                  >
                    {breadcrumbDict.name}
                  </Breadcrumb.Item>
                );
              })}
            </Breadcrumb>
          </div>
          <Table
            rowKey="uuid"
            loading={isLoading}
            columns={this.columns()}
            dataSource={data}
            pagination={pagination}
          />
          <ModalDictAdd
            parentLevelCode={parentLevelCode}
            visible={visible}
            data={dataInfo}
            onOk={params => this.saveDict(params)}
            onCancel={() => this.handlerVisible(false)}
          />
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  account_info: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(Index));



// WEBPACK FOOTER //
// ./src/components/boss/dict/Index.js